// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "homepage",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data(){
        return {
            chartPreviousYear: [
                {
                    pid: '2471',
                    imgPath: '2021/2471.jpg',
                    selected: false,
                    ranking: '1°'
                },
                {
                    pid: '2728',
                    imgPath: '2021/2728.jpg',
                    selected: false,
                    ranking: '2°'
                },
                {
                    pid: "1273",
                    imgPath: '2021/1273.jpg',
                    selected: false,
                    ranking: '3°'
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}